"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.OmniChatUniversalEmitterProvider = exports.useUniversalEmitter = exports.UniversalEmitterContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var toolkit_1 = require("@moopsyjs/toolkit");
var react_1 = __importDefault(require("react"));
exports.UniversalEmitterContext = react_1["default"].createContext(null);
var useUniversalEmitter = function () {
    var ctxValue = react_1["default"].useContext(exports.UniversalEmitterContext);
    if (ctxValue === null) {
        throw new Error("@hiyllo/omni-chat hooks require OmniChatUniversalEmitterProvider");
    }
    return ctxValue;
};
exports.useUniversalEmitter = useUniversalEmitter;
exports.OmniChatUniversalEmitterProvider = react_1["default"].memo(function OmniChatUniversalEmitterProvider(props) {
    var emitter = react_1["default"].useMemo(function () { return new toolkit_1.TypedEventEmitterV3(); }, []);
    return (0, jsx_runtime_1.jsx)(exports.UniversalEmitterContext.Provider, __assign({ value: emitter }, { children: props.children }));
});
